<template>
  <div class="anti-fake-result">
    <div class="result fail" v-if="isError === 'true'">
      <img class="icon" :src="$IMG_BASE_URL + '/final/1_19.png'" />
      <span class="title">非{{ $store.state.encodeInfo.zhangtao }}官方销售产品</span>
      <span class="desc">此产品为非{{ $store.state.encodeInfo.zhangtao }}官方销售产品，请谨慎处理！</span>
    </div>

    <div class="result first" v-else-if="num == 1">
      <img class="icon" :src="$IMG_BASE_URL + '/final/1_16.png'" />
      <span class="title">首次验证</span>
      <span class="desc">您查询的产品为正品，此次为首次验证，请放心使用！</span>
    </div>

    <div class="result two-three-four" v-else-if="num > 1 && num <= 4">
      <img class="icon" :src="$IMG_BASE_URL + '/final/1_17.png'" />
      <span class="title">第{{ num }}次验证</span>
      <span class="desc">您查询的产品为正品，此次为第{{ num }}次验证！</span>
      <span class="desc">上一次验证时间为：{{ lastTime }}</span>
    </div>

    <div class="result more" v-else-if="num >= 5">
      <img class="icon" :src="$IMG_BASE_URL + '/final/1_18.png'" />
      <span class="title">多次验证</span>
      <span class="desc">您查询的产品为正品，产品已被多次验证！</span>
    </div>

    <footer></footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lastTime: '',
      num: '',
      isError: 'false'
    }
  },

  created() {
    const { lastTime, num, isError } = this.$route.query
    this.lastTime = lastTime
    this.num = num
    this.isError = isError
  }
}
</script>

<style scoped lang="less">
.anti-fake-result {
  .flex-center(@direction: column);

  .result {
    display: flex;
    flex-direction: column;
    align-items: center;

    .icon {
      width: 226px;
      height: 123px;
    }

    .title {
      margin-bottom: 10px;
      font-weight: bold;
      font-size: 18px;
    }

    .desc {
      font-size: 12px;
      line-height: 20px;
      color: #888;
    }
  }

  .fail {
    .title {
      color: #e40000;
    }
  }
}
</style>
